import { BotsManagementWsEvent } from "features/ws/botsManagementWs";

export const CAPTCHA_BOT_STATUS = "CAPTCHA";

export function isCaptchaWaiting(
  botWorkStatus?: string | null,
  captchaStatus?: string | null,
): boolean {
  return (
    (botWorkStatus || "").toUpperCase() === CAPTCHA_BOT_STATUS &&
    ["pending", "ready"].includes((captchaStatus || "").toLowerCase())
  );
}

/** Open the dialog when a bot starts waiting, close it when it stops. */
export function captchaPromptAction(
  event: BotsManagementWsEvent,
): { taskId: number; open: boolean } | null {
  const taskId = event.task?.task_id;
  if (typeof taskId !== "number") return null;

  const botStatus = event.task?.bot_work_status;
  if (event.event === "captcha.updated") {
    if (botStatus && botStatus.toUpperCase() !== CAPTCHA_BOT_STATUS) {
      return { taskId, open: false };
    }
    return { taskId, open: true };
  }
  if (botStatus && botStatus.toUpperCase() !== CAPTCHA_BOT_STATUS) {
    return { taskId, open: false };
  }
  return null;
}
